import { Loader, LoaderOptions } from 'google-maps';
import { MarkerClusterer } from "@googlemaps/markerclusterer";


class Map {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-map="scope"]',
			map: '[data-map="map"]',
			infoWindow: '[data-map="location"]',
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.each((index, scope) => {
			let $scope = $(scope);

			// Lazyload
			this.initSpecific($scope);
			$(window).on('resize scroll', () => this.initSpecific($scope));
		});
	}

	initSpecific($scope) {
		// Already initialized so return
		if($scope.data('initialized')) {
			return;
		}

		// Is not in viewport yet so return
		if (!$scope.isInViewport()) {
			return;
		}

		$scope.data('initialized', true);

		let $map = $scope.find(this.config.map);

		new Promise(async (resolve) => {
			this.initLoader($map);
			await this.initMap($map);
			await this.initMarkers($scope);
			resolve(true);
		}).then(() => {
			this.addEventListeners()
		})
	}

	addEventListeners() {
		let infowindow = new this.google.maps.InfoWindow({
			pixelOffset: new google.maps.Size(0,0)
		});
		this.markers.forEach((el, it) => {
			google.maps.event.addListener(el, 'click', () => {
				infowindow.setContent(el.infoWindowHtml);
				infowindow.open(this.map, el);
			});
		})
	}

	initLoader($map) {
		this.loader = new Loader($map.data('key'));
	}

	async initMap($map) {
		this.google = await this.loader.load();
		this.map = new this.google.maps.Map($map[0], {
			center: {
				lat: 52.25,
				lng: 5.40
			},
			zoom: 8
		})
	}

	async initMarkers($scope) {
		this.markers = [];

		let bounds = new this.google.maps.LatLngBounds();

		$scope.find(this.config.infoWindow).each((index, element) => {
			let $element = $(element);

			if (!$element.data('latitude') || !$element.data('longitude')) {
				return;
			}

			let marker = new this.google.maps.Marker({
				position: {
					lat: parseFloat($element.data('latitude')),
					lng: parseFloat($element.data('longitude'))
				},
				map: this.map,
				infoWindowHtml: $element.html()
			});

			this.markers.push(marker);
			bounds.extend(marker.position);
		})

		//now fit the map to the newly inclusive bounds
		this.map.fitBounds(bounds);

		// Add a marker clusterer to manage the markers.
		new MarkerClusterer({
			markers: this.markers,
			map: this.map
		});
	}

	getIcon($element) {
		return '/image/google-maps-icon.svg';
	}

}

export default Map;
